export default __webpack_public_path__ + "static/media/fg1.b608cb1f.png";